export default __webpack_public_path__ + "static/media/close-circle.ee66a245.svg";